import { render, staticRenderFns } from "./SettingsWidget.vue?vue&type=template&id=149b5dc8&scoped=true&"
import script from "./SettingsWidget.vue?vue&type=script&lang=js&"
export * from "./SettingsWidget.vue?vue&type=script&lang=js&"
import style0 from "./SettingsWidget.vue?vue&type=style&index=0&id=149b5dc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149b5dc8",
  null
  
)

export default component.exports